import { useEffect, useState } from "react";

const Q = "(min-width: 1024px)";

export function useIsDesktop() {
  const [on, setOn] = useState(() => window.matchMedia(Q).matches);
  useEffect(() => {
    const m = window.matchMedia(Q);
    const h = (e) => setOn(e.matches);
    m.addEventListener("change", h);
    return () => m.removeEventListener("change", h);
  }, []);
  return on;
}
